"use strict";
exports.__esModule = true;
exports.Events = exports.ScreenParent = exports.ExerciseInteractionType = exports.ExerciseType = exports.AwardType = exports.MediaType = exports.ActivityProgressType = exports.ActivityType = exports.ComponentType = void 0;
var ComponentType;
(function (ComponentType) {
    ComponentType["ACTIVITY_COVER"] = "ACTIVITY_COVER";
    ComponentType["TUTOR_BADGE"] = "TUTOR_BADGE";
})(ComponentType = exports.ComponentType || (exports.ComponentType = {}));
var ActivityType;
(function (ActivityType) {
    ActivityType["READING"] = "READING";
    ActivityType["LISTENING"] = "LISTENING";
    ActivityType["TUTOR_SET"] = "TUTOR_SET";
    ActivityType["TUTOR_CHECK_IN"] = "TUTOR_CHECK_IN";
    ActivityType["PT_ONBOARDING"] = "PT_ONBOARDING";
})(ActivityType = exports.ActivityType || (exports.ActivityType = {}));
var ActivityProgressType;
(function (ActivityProgressType) {
    ActivityProgressType["SECTION_STARTED"] = "SECTION_STARTED";
    ActivityProgressType["SECTION_COMPLETED"] = "SECTION_COMPLETED";
    ActivityProgressType["START_TUTOR_FEEDBACK"] = "START_TUTOR_FEEDBACK";
})(ActivityProgressType = exports.ActivityProgressType || (exports.ActivityProgressType = {}));
var MediaType;
(function (MediaType) {
    MediaType["AUDIO"] = "AUDIO";
    MediaType["VIDEO"] = "VIDEO";
})(MediaType = exports.MediaType || (exports.MediaType = {}));
var AwardType;
(function (AwardType) {
    AwardType["STAR"] = "STAR";
    AwardType["LEVEL_UP"] = "LEVEL_UP";
    AwardType["ACHIEVEMENT"] = "ACHIEVEMENT";
})(AwardType = exports.AwardType || (exports.AwardType = {}));
var ExerciseType;
(function (ExerciseType) {
    ExerciseType["WORLD_BUILDER"] = "WORLD_BUILDER";
    ExerciseType["MULTI_CHOICE_QUESTION"] = "MULTI_CHOICE_QUESTION";
    ExerciseType["CONVERSATION"] = "CONVERSATION";
    ExerciseType["READ_SENTENCE"] = "READ_SENTENCE";
    ExerciseType["READ_WORD_RACE"] = "READ_WORD_RACE";
    ExerciseType["WORD_PRACTICE"] = "WORD_PRACTICE";
    ExerciseType["SENTENCE_BUILDER"] = "SENTENCE_BUILDER";
    ExerciseType["OTHER"] = "OTHER";
})(ExerciseType = exports.ExerciseType || (exports.ExerciseType = {}));
var ExerciseInteractionType;
(function (ExerciseInteractionType) {
    ExerciseInteractionType["RECORD_MEDIA"] = "RECORD_MEDIA";
    ExerciseInteractionType["SELECT_ANSWER"] = "SELECT_ANSWER";
    ExerciseInteractionType["DRAG_DROP"] = "DRAG_DROP";
})(ExerciseInteractionType = exports.ExerciseInteractionType || (exports.ExerciseInteractionType = {}));
var ScreenParent;
(function (ScreenParent) {
    ScreenParent["APP"] = "APP";
    ScreenParent["TUTOR_SET"] = "TUTOR_SET";
    ScreenParent["TUTOR_CHECK_IN"] = "TUTOR_CHECK_IN";
    ScreenParent["PT_ONBOARDING"] = "PT_ONBOARDING";
})(ScreenParent = exports.ScreenParent || (exports.ScreenParent = {}));
var Events;
(function (Events) {
    var ScreenShown = (function () {
        function ScreenShown(struct) {
            this.struct = struct;
            this.name = 'Screen Shown';
            this.props = Object.freeze({
                schema_version: 2,
                screen_parent: this.struct.screen_parent,
                screen_name: this.struct.screen_name
            });
        }
        return ScreenShown;
    }());
    Events.ScreenShown = ScreenShown;
    var ComponentShown = (function () {
        function ComponentShown(struct) {
            this.struct = struct;
            this.name = 'Component Shown';
            this.props = Object.freeze({
                schema_version: 2,
                component_type: this.struct.component_type,
                component_name: this.struct.component_name,
                clickable: this.struct.clickable,
                component_value: this.struct.component_value,
                screen_name: this.struct.screen_name
            });
        }
        return ComponentShown;
    }());
    Events.ComponentShown = ComponentShown;
    var ActivityStarted = (function () {
        function ActivityStarted(struct) {
            this.struct = struct;
            this.name = 'Activity Started';
            this.props = Object.freeze({
                schema_version: 2,
                activity_type: this.struct.activity_type,
                activity_title: this.struct.activity_title,
                activity_id: this.struct.activity_id,
                activity_screen_name: this.struct.activity_screen_name,
                from: this.struct.from
            });
        }
        return ActivityStarted;
    }());
    Events.ActivityStarted = ActivityStarted;
    var ActivityResumed = (function () {
        function ActivityResumed(struct) {
            this.struct = struct;
            this.name = 'Activity Resumed';
            this.props = Object.freeze({
                schema_version: 2,
                activity_type: this.struct.activity_type,
                activity_title: this.struct.activity_title,
                activity_id: this.struct.activity_id,
                activity_screen_name: this.struct.activity_screen_name,
                from: this.struct.from
            });
        }
        return ActivityResumed;
    }());
    Events.ActivityResumed = ActivityResumed;
    var ActivityCompleted = (function () {
        function ActivityCompleted(struct) {
            this.struct = struct;
            this.name = 'Activity Completed';
            this.props = Object.freeze({
                schema_version: 2,
                activity_type: this.struct.activity_type,
                activity_title: this.struct.activity_title,
                activity_id: this.struct.activity_id
            });
        }
        return ActivityCompleted;
    }());
    Events.ActivityCompleted = ActivityCompleted;
    var ActivityProgressed = (function () {
        function ActivityProgressed(struct) {
            this.struct = struct;
            this.name = 'Activity Progressed';
            this.props = Object.freeze({
                schema_version: 2,
                activity_type: this.struct.activity_type,
                activity_title: this.struct.activity_title,
                activity_id: this.struct.activity_id,
                progress_type: this.struct.progress_type,
                progress_value: this.struct.progress_value
            });
        }
        return ActivityProgressed;
    }());
    Events.ActivityProgressed = ActivityProgressed;
    var MediaStarted = (function () {
        function MediaStarted(struct) {
            this.struct = struct;
            this.name = 'Media Started';
            this.props = Object.freeze({
                schema_version: 2,
                source: this.struct.source,
                source_title: this.struct.source_title,
                source_id: this.struct.source_id,
                media_type: this.struct.media_type,
                media_title: this.struct.media_title,
                media_id: this.struct.media_id
            });
        }
        return MediaStarted;
    }());
    Events.MediaStarted = MediaStarted;
    var MediaDisrupted = (function () {
        function MediaDisrupted(struct) {
            this.struct = struct;
            this.name = 'Media Disrupted';
            this.props = Object.freeze({
                schema_version: 2,
                source: this.struct.source,
                source_title: this.struct.source_title,
                source_id: this.struct.source_id,
                media_type: this.struct.media_type,
                media_title: this.struct.media_title,
                media_id: this.struct.media_id,
                disrupt_reason: this.struct.disrupt_reason
            });
        }
        return MediaDisrupted;
    }());
    Events.MediaDisrupted = MediaDisrupted;
    var RecordingStarted = (function () {
        function RecordingStarted(struct) {
            this.struct = struct;
            this.name = 'Recording Started';
            this.props = Object.freeze({
                schema_version: 2,
                source: this.struct.source,
                source_title: this.struct.source_title,
                source_id: this.struct.source_id,
                media_type: this.struct.media_type,
                recording_title: this.struct.recording_title
            });
        }
        return RecordingStarted;
    }());
    Events.RecordingStarted = RecordingStarted;
    var RecordingEnded = (function () {
        function RecordingEnded(struct) {
            this.struct = struct;
            this.name = 'Recording Ended';
            this.props = Object.freeze({
                schema_version: 2,
                source_type: this.struct.source_type,
                source_title: this.struct.source_title,
                source_id: this.struct.source_id,
                media_type: this.struct.media_type,
                recording_title: this.struct.recording_title,
                recording_length_sec: this.struct.recording_length_sec
            });
        }
        return RecordingEnded;
    }());
    Events.RecordingEnded = RecordingEnded;
    var RecordingSent = (function () {
        function RecordingSent(struct) {
            this.struct = struct;
            this.name = 'Recording Sent';
            this.props = Object.freeze({
                schema_version: 2,
                source_type: this.struct.source_type,
                source_title: this.struct.source_title,
                source_id: this.struct.source_id,
                media_type: this.struct.media_type,
                recording_title: this.struct.recording_title,
                recording_length_sec: this.struct.recording_length_sec
            });
        }
        return RecordingSent;
    }());
    Events.RecordingSent = RecordingSent;
    var AwardEarned = (function () {
        function AwardEarned(struct) {
            this.struct = struct;
            this.name = 'Awarded Earned';
            this.props = Object.freeze({
                schema_version: 2,
                award_type: this.struct.award_type,
                award_name: this.struct.award_name,
                award_value: this.struct.award_value,
                activity_type: this.struct.activity_type,
                activity_title: this.struct.activity_title,
                activity_id: this.struct.activity_id
            });
        }
        return AwardEarned;
    }());
    Events.AwardEarned = AwardEarned;
    var ExerciseStarted = (function () {
        function ExerciseStarted(struct) {
            this.struct = struct;
            this.name = 'Exercise Started';
            this.props = Object.freeze({
                schema_version: 2,
                exercise_type: this.struct.exercise_type,
                exercise_title: this.struct.exercise_title,
                exercise_id: this.struct.exercise_id,
                activity_type: this.struct.activity_type,
                activity_title: this.struct.activity_title,
                activity_id: this.struct.activity_id
            });
        }
        return ExerciseStarted;
    }());
    Events.ExerciseStarted = ExerciseStarted;
    var ExerciseInteracted = (function () {
        function ExerciseInteracted(struct) {
            this.struct = struct;
            this.name = 'Exercise Interacted';
            this.props = Object.freeze({
                schema_version: 2,
                exercise_type: this.struct.exercise_type,
                exercise_title: this.struct.exercise_title,
                exercise_id: this.struct.exercise_id,
                interaction_type: this.struct.interaction_type,
                activity_type: this.struct.activity_type,
                activity_title: this.struct.activity_title,
                activity_id: this.struct.activity_id,
                score: this.struct.score
            });
        }
        return ExerciseInteracted;
    }());
    Events.ExerciseInteracted = ExerciseInteracted;
    var ExerciseCompleted = (function () {
        function ExerciseCompleted(struct) {
            this.struct = struct;
            this.name = 'Exercise Completed';
            this.props = Object.freeze({
                schema_version: 2,
                exercise_type: this.struct.exercise_type,
                exercise_title: this.struct.exercise_title,
                exercise_id: this.struct.exercise_id,
                activity_type: this.struct.activity_type,
                activity_title: this.struct.activity_title,
                activity_id: this.struct.activity_id,
                exercise_score: this.struct.exercise_score
            });
        }
        return ExerciseCompleted;
    }());
    Events.ExerciseCompleted = ExerciseCompleted;
})(Events = exports.Events || (exports.Events = {}));
//# sourceMappingURL=event-schema.js.map